/** @jsx jsx */
import React from 'react';

import SelectForm from 'components/molecules/SelectForm';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import FormLabel from 'components/atoms/Form/FormLabel';
import FlexBox from 'components/atoms/FlexBox';
import {
} from 'components/styles';
import DataTable from 'components/organismos/DataTable/DataTable';
import { css, jsx } from '@emotion/core';
import Accordion from 'components/molecules/Accordion';
import SpecialHolidayGrantHistoryDomain from 'domain/master/holidayManagement/specialHolidayGrantHistory';
import { Column } from 'react-table';

import IconLabelButton from 'components/molecules/IconLabelButton';
import CalendarForm from 'components/molecules/CalendarForm';
import { isSafari, isIPad13, isTablet } from 'react-device-detect';
import { useSpecialHolidayGrantHistoryDomainForm, useDownloadHolidayManagementSpecialHolidayGrantHistory } from './hooks';
import BlockUI from 'components/molecules/BlockUi';
import FormPadding from 'components/atoms/Form/FormPadding';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import CalendarRangeV2 from 'components/molecules/CalendarV1/CalendarRangeV2';

// create style form
const styles = {
  form: css({
    paddingTop: '15px',
  }),
  wrapper: css({
    display: 'flex',
    width: '150px',
    float: 'left',
  }),
  container: css({
    padding: '4px 0',
  }),
  label: css({
    flexBasis: '100px',
  }),
  select: css({
    flexGrow: 4,
    minWidth: '100px',
  }),
  digestionDays: css({
    width: '200px',
  }),
  betweenDays: css({
    width: '50px',
    textAlign: 'center',
    color: '#666666'
  }),
  input: css({
    maxWidth: '600px',
    padding: '30px',
    marginBottom: '30px',
  }),
  wrapAccordion: css({
    backgroundColor: '#fff',
    border: '1px solid #dcdcdc',
  }),
  center: css({
    textAlign: 'center',
    justifyContent: 'center',
  }),
  globalSearch: css({
    marginLeft: '30px',
    marginBottom: '10px',
  }),
  backgroundWhite: css({
    backgroundColor: '#fff',
  }),
  customStyle: css({
    display: 'flex',
    justifyContent: ((isSafari && isTablet) || isIPad13) ? 'flex-start' : 'flex-end',
    paddingRight: ((isSafari && isTablet) || isIPad13) ? '10px' : '30px',
    marginBottom: ((isSafari && isTablet) || isIPad13) ? '0px' : '-55px',
  }, css`
    button{
      width:auto;
      margin-left:15px
    }
    button:hover{
      background:transparent
    }
    button svg{
      width:20px !important;
      height:20px !important;
    }`)
};

const GrantHistoryForm: React.FC<
  {
    arrGrantResult: any,
    orgTreesOptions: any,
    currentAccordionList: any,
    setCurrentAccordionList: any
  }> = (
    {
      arrGrantResult,
      orgTreesOptions,
      currentAccordionList,
      setCurrentAccordionList,
    },
  ) => {
    const {
      paidHolidayGrantHistoryList,
      orgCode,
      setOrgCode,
      targetDateFrom,
      setTargetDateFrom,
      targetDateTo,
      setTargetDateTo,
    } = useSpecialHolidayGrantHistoryDomainForm();

    const {
      downloadHolidayManagementSpecialHolidayGrantHistory, blocking
    } = useDownloadHolidayManagementSpecialHolidayGrantHistory(
      orgCode,
      targetDateFrom,
      targetDateTo,
    );
    //
    const columns: Array<Column<SpecialHolidayGrantHistoryDomain>> = React.useMemo(() => [
      {
        Header: 'スタッフコード',
        accessor: 'staffCode',
      },
      {
        Header: 'スタッフ名',
        accessor: 'staffName',
      },
      {
        Header: '休暇名',
        accessor: 'holidayName',
      },
      {
        Header: '付与日',
        accessor: 'grantDate',
      },
      {
        Header: '付与種別',
        accessor: 'grantTypeStr',
      },
      {
        Header: '付与日数',
        accessor: 'grantDaysNumStr',
      },
      {
        Header: '前回消化日数',
        accessor: 'lastDigestedDaysNumStr',
      },
      {
        Header: '前回消滅日数',
        accessor: 'lastExtinctionDaysNumStr',
      },
    ], []);

    return (
      <BlockUI blocking={blocking}>
        <Accordion text="付与履歴" callBack={() => { }}>
          <div css={styles.backgroundWhite}>
            {/* <FormContentFilter> */}
            <FormPadding customStyle={css({ paddingTop:'16px',paddingLeft:'10px', paddingRight:'10px', maxWidth:'580px'})}>
            <FlexBox>
                  <div css={styles.label}>
                    <FormLabel
                      label="付与日"
                    />
                  </div>
                  <FlexBoxItem>
                    <CalendarRangeV2 
                    startDate={new Date(targetDateFrom)}
                    onChangeStart={(date: Date) => setTargetDateFrom(date)}
                    endDate={new Date(targetDateTo)}
                    onChangeEnd={(date) => {
                      if(date){
                        setTargetDateTo(date)
                      }
                    }}
                    /> 
                  </FlexBoxItem>
                  {/* <div css={styles.digestionDays}>
                    <CalendarForm required={true} label="" date={new Date(targetDateFrom)} dateFormat="YYYY年MM月DD日" changeDate={(date: Date) => setTargetDateFrom(date)} />
                  </div>
                  <div css={styles.betweenDays}> ～ </div>
                  <div css={styles.digestionDays}>
                    <CalendarForm required={true} label="" date={new Date(targetDateTo)} dateFormat="YYYY年MM月DD日" changeDate={(date: Date) => setTargetDateTo(date)} />
                  </div> */}
                </FlexBox>
            </FormPadding>
            <FormPadding customStyle={css({paddingLeft:'10px', paddingRight:'10px', maxWidth:'580px'})}>
            <SelectForm
                label="組織"
                name="orgCode002"
                value={String(orgCode)}
                setValue={(val: string) => setOrgCode(val)}
                options={orgTreesOptions}
              />  
            </FormPadding>
            {/* </FormContentFilter> */}
            <div
              css={css`
              table th:nth-of-type(1) {
                width: 140px;
              }
              table th:nth-of-type(2) {
                width: 100px;
              }
              table th:nth-of-type(3) {
                width: 100px;
              }
              table th:nth-of-type(4) {
                width: 140px;
              }
              table th:nth-of-type(5) {
                width: 100px;
              }
              table th:nth-of-type(6) {
                width: 80px;
              }
              table th:nth-of-type(7) {
                width: 100px;
              }
              table th:nth-of-type(8) {
                width: 100px;
              }
              table th:nth-of-type(9) {
                width: 100px;
              }
              table th:nth-of-type(10) {
                width: 200px; 
              } 
              table td { 
                white-space: pre-line;
              } 
            `}
            >
              <FormSubmitArea customStyle={styles.customStyle}>
                <IconLabelButton onClick={() => downloadHolidayManagementSpecialHolidayGrantHistory()} iconType="download" text="ダウンロード" />
                {/* <IconLabelButton onClick={() => downloadHolidayManagementSpecialHolidayGrantHistory(true)} iconType="download" text="全組織ダウンロード" /> */}
              </FormSubmitArea>
              <div className="table-bordered" style={{ overflowX: 'auto', whiteSpace: 'nowrap', marginTop: '10px', padding:'0 10px 10px' }}>
                <DataTable
                  classNameParrant="border-left-right"
                  className="table-no-border-left-right"
                  columns={columns}
                  data={paidHolidayGrantHistoryList}
                  isGlobalFilter={true}
                  minWidth="924px"
                  // globalSearchStyle={styles.globalSearch}
                />
              </div>
            </div>
          </div>
        </Accordion>
      </BlockUI>
    );
  };
export default GrantHistoryForm;
